import {Component, OnInit} from '@angular/core';

//services
import { InformationService} from '../services/information.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    providers: [ InformationService ]
})
export class HomeComponent implements OnInit{
    welcome : string;
    subtitle : string;
    description: string;

    constructor(private informationService: InformationService){
        this.welcome = "Who am I?";
        this.subtitle = "A little description about myself.";
        this.description = "Loading...";
    }

    async ngOnInit() {
        this.description = await this.informationService.getDescription();
    }
};